import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern Living kit — a built-in dishwasher, 0.6 x 0.6 x 0.85 m: steel front
// door with a slim control strip and bar handle, topped with the same worktop
// colour as the kitchen counter so it slots into a counter run.
const STEEL = "#aab2b8";
const DOOR = "#b4bcc2";
const WORKTOP = "#d8d5cf";
const MATTE_BLACK = "#2e2e30";

export const dishwasher = defineModel({
  id: "dishwasher",
  batchId: "modern",
  name: "Dishwasher",
  tags: ["modern", "interior", "appliance", "kitchen", "dishwasher"],
  summary: "A built-in dishwasher with a steel door and a worktop-matching top.",
  tiles: { w: 1, h: 1 },
  footprint: 0.7,
  parts(): Part[] {
    return [
      // recessed plinth
      { geometry: new THREE.BoxGeometry(0.52, 0.1, 0.44), color: MATTE_BLACK, position: [0, 0.05, -0.04] },
      // carcass (back flush at z = -0.3)
      { geometry: new THREE.BoxGeometry(0.6, 0.71, 0.56), color: STEEL, position: [0, 0.455, -0.02] },
      // steel front door
      { geometry: new THREE.BoxGeometry(0.56, 0.56, 0.02), color: DOOR, position: [0, 0.4, 0.28] },
      // slim control strip above the door
      { geometry: new THREE.BoxGeometry(0.56, 0.08, 0.02), color: MATTE_BLACK, position: [0, 0.73, 0.28] },
      // bar handle
      { geometry: new THREE.BoxGeometry(0.44, 0.03, 0.03), color: MATTE_BLACK, position: [0, 0.64, 0.31] },
      // worktop-matching top (top surface at 0.85)
      { geometry: new THREE.BoxGeometry(0.6, 0.04, 0.6), color: WORKTOP, position: [0, 0.83, 0] },
    ];
  },
  animations: [],
});
